module.exports = __webpack_public_path__ + "img/27.63dbb7d0.png";